// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";  // ← add this
import { HelmetProvider } from "react-helmet-async";
import ErrorBoundary from "./components/ErrorBoundary";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>          {/* ← add this */}
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </BrowserRouter>          {/* ← and this */}
    </HelmetProvider>
  </React.StrictMode>
);